<template>
  <div>
	<div class="link-box" @click="goPage" v-if="is_show_link"> </div>
    <!-- <div class="xuanchuan">
			<img src="https://img.51xinlong.com/xladmin/static/ecology/xuanchuan.jpg" />
		</div> -->
    <div
      :class="
        this.$config.domain.ename == 'yifuxin' ? 'mainboard-yfx' : 'mainboard'
      "
    >
      <div class="centerArea">
        <div class="bFix">
          <img
            class="bFixImg"
            src="https://img.51xinlong.com/xladmin/static/ecology/bottomBgB.png"
          />
          <div class="white">
            <img
              style="width: 19vw"
              src="https://img.51xinlong.com/xladmin/static/ecology/bottomTxt.png"
            />
            <!-- 						<span>灵工</span>
						<span class="line"></span>
						<span>系统</span>
						<span class="line"></span>
						<span>生态</span> -->
          </div>
        </div>
        <img
          v-if="this.$config.domain.ename == 'kuaihuolong'"
          class="logo"
          src="https://img.51xinlong.com/xladmin/static/ecology/indexBg-logo.png"
        />
        <div class="mainwrap">
          <div
            @click="tapItem(item)"
            :key="index"
            v-for="(item, index) in arr"
            class="item"
          >
            <img
              :class="'icon icon' + (index + 1)"
              style="margin-right: 12px"
              :src="item.icon"
            />
            <div class="right">
              <span>{{ item.subTitle }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
		is_show_link:false,
      arr: [
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/newIcon1.png",
          name: "灵活用工系统",
          url: "/home",
          subTitle: "灵活用工一站式操作系统",
          width: 143,
          active: false,
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/newIcon2.png",
          name: "园区资源",
          url: "/mainDetail",
          arg: {
            type: 2,
          },
          subTitle: "更多的灵活用工园区资源适用不同场景",
          width: 119,
          active: false,
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/newIcon3.png",
          name: "龙保宝",
          url: "/mainDetail",
          arg: {
            type: 3,
          },
          subTitle: "专注新就业形态职业伤害责任保险方案",
          width: 70,
          active: false,
        },
        {
          icon: "https://img.51xinlong.com/xladmin/static/ecology/newIcon4.png",
          name: "灵工贷",
          url: "/mainDetail",
          arg: {
            type: 4,
          },
          subTitle: "为灵活用工企业量身打造的金融产品",
          width: 71,
          active: false,
        },
      ],
    };
  },
  methods: {
	goPage(){
	//测试 https://togtestb2b.51xinlong.com/  正式 https://b2b.51xinlong.com
	let url=''
	let status='pro' // 正式 pro  测试 dev
	if(status==='dev'){
		url='https://togtestb2b.51xinlong.com'
	}else{
		url='https://www.51xinlong.com/'
	}
	
	window.open(url)
	},
    go(url = "/", obj = {}) {
      this.mxRedirect(url, obj);
    },
    // 点击每项
    tapItem(e) {
      if (e.url) {
        let obj = {};
        if (e.arg) {
          obj = e.arg;
        }
        this.go(e.url, obj);
      }
    },
  },
  created() {
this.is_show_link=['trade.51xinlong.com'].includes(window.location.host)
    console.log();
  },
};
</script>

<style scoped>
	.link-box{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 3;
		height: 60px;
		background-image: url(https://xl-online.oss-cn-hangzhou.aliyuncs.com/images/desc_link.png);
		background-repeat: no-repeat;
		background-size: 100%;
		width: 100%;
		cursor: pointer;
	}
.xuanchuan {
  display: flex;
}

.xuanchuan img {
  width: 100%;
}

.bFix {
  display: flex;
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: 0px;
  flex-direction: column;
  z-index: 9999;
  height: 25%;
}
.bFixImg {
  width: 100%;
}

.bFix .white {
  display: flex;
  background-color: #fff;
  height: 4em;
  margin-top: -4px;
  font-size: 1.875vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4a98f8;
  justify-content: center;
  align-items: center;
}

.line {
  height: 4.444vh;
  width: 2px;
  background-color: #4a98f8;
  margin: 0px 40px;
}

.subTitleActive {
  color: #fff;
}
.mainTitle {
  font-size: 30px;
}
.mainwrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 10vh;
}

.item {
  width: 466px;
  height: 112px;
  width: 24.27vw;
  height: 10.37vh;
  background-color: #fff;
  border-radius: 15px;
  margin-bottom: 20px;
  margin-right: 20px;
  cursor: pointer;
  transition: all ease-in-out 0.3s;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 5.625vw;
  box-sizing: border-box;
  position: relative;
}

.item:nth-child(2),
.item:nth-child(4) {
  margin-right: 0px;
}

.item .right {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 8.333vw;
  top: 5.9259vh;
  font-size: 0.729vw;
}
.right img {
  margin-bottom: 6px;
  height: 22px;
  width: auto;
}

.item:hover {
  transform: translateY(-10px);
  transition: all ease-in-out 0.3s;
}

.item:hover .icon {
}

.icon {
}

.mainboard {
  display: flex;
  height: 100vh;
  background-image: url("https://img.51xinlong.com/xladmin/static/ecology/indexBgNewest.png");
  background-size: 100%;
  overflow: hidden;
  justify-content: center;
  position: relative;
}
.mainboard-yfx {
  display: flex;
  height: 100vh;
  background-image: url("https://img.51xinlong.com/xladmin/static/images/yfx/yfxbanner.jpg");
  background-size: 100%;
  overflow: hidden;
  justify-content: center;
  position: relative;
}

.centerArea {
  width: 59.5rem;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.centerArea .logo {
  position: absolute;
  left: 17.34vw;
  top: 8vh;
  width: 147px;
  height: 42px;
}

.bottomFix {
  position: absolute;
  width: 100%;
  height: 48px;
  left: 0px;
  bottom: 10.277vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4a98f8;
  line-height: 46px;
}

.bottomFix .line {
  height: 48px;
  width: 1px;
  background-color: #458fff;
  margin: 0px 40px;
}

.wenzi {
  margin-top: 13.3125rem;
  width: 39.0625rem;
  height: auto;
}

.icon1 {
  width: 10.26vw;
  height: auto;
}
.icon2 {
  width: 7.76vw;
  height: auto;
}
.icon3 {
  width: 6.406vw;
  height: auto;
}
.icon4 {
  width: 6.458vw;
  height: auto;
}
</style>
